import React from "react";
import "./GenderSelect.css";

export const USER_GENDER_MALE = "male";
export const USER_GENDER_FEMALE = "female";

export const formatGenderLabel = (gender) => {
  if (gender === USER_GENDER_MALE) return "Мужской";
  if (gender === USER_GENDER_FEMALE) return "Женский";
  return "Не указано";
};

function GenderSelect({
  value,
  onChange,
  name = "gender",
  required = false,
  disabled = false,
}) {
  const handleChange = (nextGender) => {
    if (disabled) return;
    onChange({
      target: {
        name,
        value: value === nextGender ? "" : nextGender,
      },
    });
  };

  return (
    <div className={`gender-select${disabled ? " gender-select--disabled" : ""}`}>
      <label className="gender-select__option">
        <input
          type="checkbox"
          className="gender-select__checkbox"
          checked={value === USER_GENDER_MALE}
          onChange={() => handleChange(USER_GENDER_MALE)}
          required={required && !value}
          disabled={disabled}
        />
        <span className="gender-select__label">Мужской</span>
      </label>
      <label className="gender-select__option">
        <input
          type="checkbox"
          className="gender-select__checkbox"
          checked={value === USER_GENDER_FEMALE}
          onChange={() => handleChange(USER_GENDER_FEMALE)}
          required={required && !value}
          disabled={disabled}
        />
        <span className="gender-select__label">Женский</span>
      </label>
    </div>
  );
}

export default GenderSelect;
